const titleCase = (str) => str[0].toUpperCase() + str.slice(1).toLowerCase();

const formatFilterName = (name) => (name ? titleCase(name.split(/(?=[A-Z])/)[0]) : '');

const formatStatus = (name) => (name ? name.toString().trim().replace(/\s+/g, '-').toUpperCase() : '');

const formatPrice = (name) => (name ? name.trim().replace(/\$/g, '').replace(/&/g, '').replace(/\s+/g, '|').replace(/-/g, '|').toUpperCase() : '');

const deFormatPrice = (name) => {
  if (/^\d+(\|\d+)$/.test(name)) {
    const price = name.split('|');
    return `Custom: ${price[0]} - ${price[1]}`;
  }
  return name;
};

const formatFacetValues = (facet) =>
  Object.keys(facet)
    ?.map((key) => `${deFormatPrice(key)} (${facet[key]})`)
    ?.join(', ');

const deFormatStatus = (filter, selected) => selected?.map((item) => filter?.find((subItem) => formatStatus(subItem?.status) === item)?.status);

const sort = (data, property, type) => {
  let sortedValues = data.filter((item) => item[property] && !item.isGiftCard);
  const unsortedValues = data.filter((item) => !item[property] && !item.isGiftCard);
  const priorityUnsortedValues = data.filter((item) => !!item.isGiftCard);
  const startIndex = type === 'ASCENDING' ? 1 : -1;
  const endIndex = type === 'ASCENDING' ? -1 : 1;
  sortedValues = sortedValues.sort((a, b) => {
    const first = Number.isNaN(Number(a[property])) ? a[property].toUpperCase() : parseFloat(Number(a[property]));
    const last = Number.isNaN(Number(b[property])) ? b[property].toUpperCase() : parseFloat(Number(b[property]));
    if (first > last) {
      return startIndex;
    }
    if (last > first) {
      return endIndex;
    }
    return 0;
  });
  return [...priorityUnsortedValues, ...sortedValues, ...unsortedValues];
};

const transformFilters = (values, filterOrder, orgId, isGiftTracker = false) => {
  const filter = [];
  if (values) {
    Object.keys(values)?.forEach((key) => {
      const filterName = formatFilterName(key).toUpperCase();
      const filterValues = [];
      values[key].forEach((item) => {
        if (filterName === 'CATEGORY') {
          filterValues.push({
            label: item.categoryName,
            value: item.categoryName,
          });
        } else if (filterName === 'STATUS') {
          if (orgId === 12) {
            filterValues.push({
              label: item.status,
              value: isGiftTracker ? formatStatus(item.status) : item.status,
            });
          } else {
            const statusValues = item.status?.split(' ');
            const statusItem =
              statusValues.length > 1
                ? `${statusValues.reduce((status, value, index) => {
                    if (index === 0) {
                      return `${status} ${value}`;
                    }
                    return `${status} ${value?.toLowerCase()}`;
                  }, '')}`
                : item.status;
            filterValues.push({
              label: statusItem,
              value: isGiftTracker ? formatStatus(statusItem) : statusItem,
            });
          }
        } else if (filterName === 'PRICE') {
          filterValues.push({
            label: item.priceRange,
            value: item.priceRange,
          });
        }
      });
      const filterObject = {
        name: formatFilterName(key),
        facetType: filterName === 'PRICE' ? 'MULTISELECTRANGE' : 'MULTISELECTDEFAULT',
        selectedValues: [],
        values: filterValues,
      };
      filter.push(filterObject);
    });
  }
  filter.sort((a, b) => filterOrder.indexOf(a.name.toUpperCase()) - filterOrder.indexOf(b.name.toUpperCase()));
  return filter;
};

const transformFilterContent = (filter, data, isBaby = false) => {
  let facetValues = {};
  let filteredContent =
    filter && filter?.allSelected?.facets?.length > 0
      ? data.filter((item) => {
          let groupCheck = true;
          let facetSelectedValues = {};
          filter?.allSelected?.facets?.forEach((facet) => {
            let facetCheck = false;
            const facetName = facet.name.toLowerCase();
            facet.selectedValues.forEach((subItem) => {
              let subItemCheck = false;
              const price = formatPrice(subItem).split('|');
              if (facetName === 'price') {
                const originalPrice = Number.isNaN(Number(item[facetName])) ? 0 : parseFloat(Number(item[facetName]));
                if (price[0].toString() === 'UNDER' && originalPrice > 0.0 && originalPrice < parseFloat(Number(price[1]))) {
                  facetCheck = true;
                  subItemCheck = true;
                } else if (price[1].toString() === 'ABOVE' && originalPrice >= parseFloat(Number(price[0]))) {
                  facetCheck = true;
                  subItemCheck = true;
                } else if (originalPrice >= parseFloat(Number(price[0])) && originalPrice <= parseFloat(Number(price[1]))) {
                  facetCheck = true;
                  subItemCheck = true;
                }
              } else if (Array.isArray(item[facetName])) {
                item[facetName].forEach((filterName) => {
                  if (formatStatus(filterName)?.includes(formatStatus(subItem))) {
                    facetCheck = true;
                    subItemCheck = true;
                  }
                });
              } else if (formatStatus(subItem) === formatStatus(item[facetName])) {
                facetCheck = true;
                subItemCheck = true;
              }
              if (!facetSelectedValues[subItem]) {
                facetSelectedValues[subItem] = 0;
              }
              if (subItemCheck) {
                facetSelectedValues[subItem] += 1;
              }
            });
            if (!facetCheck) {
              groupCheck = false;
            }
          });
          if (!groupCheck) {
            Object.keys(facetSelectedValues).forEach((key) => {
              if (!facetValues[key]) {
                facetValues[key] = 0;
              }
            });
            facetSelectedValues = {};
            return false;
          }
          Object.keys(facetSelectedValues).forEach((key) => {
            if (!facetValues[key]) {
              facetValues[key] = 0;
            }
            facetValues[key] += facetSelectedValues[key];
          });
          return true;
        })
      : data;

  if (filter && filter?.allSelected?.sortBy) {
    const { sortBy } = filter.allSelected;
    if (sortBy !== 'RECENTLY_ADDED') {
      const [first, ...rest] = sortBy.split('_');
      const type = rest.join('_') === 'LOW_TO_HIGH' || rest.join('_') === 'OLD_TO_NEW' || rest.join('_') === 'A_TO_Z' ? 'ASCENDING' : 'DESCENDING';
      const property = first.toLowerCase();
      filteredContent = sort(filteredContent, property, type);
    }
  }
  facetValues = formatFacetValues(facetValues);
  if (!facetValues) {
    facetValues = `${isBaby ? 'All items' : 'My Gifts'} (${filteredContent.length})`;
  }
  return { filteredContent, facetValues };
};

const filterOptions = (selected, filter, type) => {
  const options = [];
  const typeName = type.toUpperCase();
  const filterTypeObject = filter?.find((item) => item.name.toUpperCase() === typeName);
  selected?.allSelected?.facets?.forEach((facet) => {
    if (facet.name.toUpperCase() === typeName) {
      facet.selectedValues.forEach((subItem) => {
        options.push(filterTypeObject?.values.find((item) => item.value === subItem)?.label);
      });
    }
  });
  return options;
};

export {
  titleCase,
  formatFilterName,
  formatStatus,
  formatPrice,
  sort,
  transformFilters,
  transformFilterContent,
  filterOptions,
  deFormatStatus,
  deFormatPrice,
};
